import React from "react";
import { renderTextCell } from "../../utils";

const Link790AAddendumBColumns = ({
  selectedIds,
  setSelectedIds,
  toggleSelectAll,
  allSelected,
}) => [
  {
    Header: ({ data }) => {
      return (
        <>
          <input
            id={`allListed`}
            className="usa-checkbox__input"
            type="checkbox"
            onChange={(e) => e}
            checked={allSelected}
            onClick={(e) => {
              toggleSelectAll();
            }}
          />
          <label
            className="usa-checkbox__label"
            // style={{ margin: 0 }}
            style={{ padding: 0, margin: "0 -3px" }}
            htmlFor={`allListed`}
            onChange={(e) => e}
            checked={allSelected}
          />
        </>
      );
    },
    disableSortBy: true,
    id: "id",
    accessor: "crop_id",
    // fixedWidth: 65,
    fixedWidth: 40,

    Cell: ({ value, row: { original }, column: { id } }) => {
      const checked = selectedIds?.includes(value);
      return (
        <>
          <input
            id={value}
            className="usa-checkbox__input"
            type="checkbox"
            checked={checked}
            onChange={(e) => e}
            onClick={(e) => {
              if (e?.currentTarget?.checked) {
                setSelectedIds((prev = []) => [...prev, value]);
              } else {
                setSelectedIds(selectedIds.filter((id) => id !== value));
              }
            }}
          />
          <label
            className="usa-checkbox__label"
            style={{
              margin: "0 0 0 -4px",
            }}
            htmlFor={value}
            onChange={(e) => e}
            checked={checked}
          />
        </>
      );
    },
  },
  {
    Header: "ID",
    id: "crop_id",
    fixedWidth: 90,
    accessor: (data) => data.crop_id,
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
  {
    Header: "Work State",
    id: "addmaCropState", // Dh's fieldname
    fixedWidth: 110,
    accessor: (data) => data.addmaCropState,
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
  {
    Header: "Crop or Agricultural Activity",
    id: "crop_name",
    accessor: (data) => data.crop_name,
    fixedWidth: 300,
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
  {
    Header: "Wage Offer",
    id: "wage_offer",
    fixedWidth: 110,
    accessor: (data) => data.wage_offer,
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
  {
    Header: "Wage Per",
    id: "wage_per",
    fixedWidth: 100,
    accessor: (data) => data.wage_per,
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
  {
    Header: "Piece Rate Offer",
    id: "addmaPieceRate",
    fixedWidth: 120,
    accessor: (data) => data.addmaPieceRate, // Dh's fieldname
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
  {
    Header: "Additional Information",
    id: "additional_info",
    accessor: (data) => data.additional_info,
    Cell: ({ value, row: { index }, column: { id } }) =>
      renderTextCell({ value, id, index, type: "selection" }),
  },
];

export default Link790AAddendumBColumns;
